import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE = `${u}/paper-trading`;

const safeList = async (r) => {
  if (!r || !r.ok) return [];
  try { const d = await r.json(); return Array.isArray(d) ? d : []; } catch { return []; }
};

const safeObj = async (r) => {
  if (!r || !r.ok) return null;
  try { return await r.json(); } catch { return null; }
};

export const getPortfolios = () =>
  apiFetch(`${BASE}/portfolios`).then(safeList);

export const getSummary = (portfolioId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/summary`).then(safeObj);

export const createPortfolio = (data) =>
  apiFetch(`${BASE}/portfolios`, { method: "POST",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(safeObj);

export const updatePortfolio = (portfolioId, data) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}`, { method: "PUT",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(safeObj);

export const deletePortfolio = (portfolioId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}`, { method: "DELETE" });

export const getTrades = (portfolioId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/trades`).then(safeList);

export const executeTrade = (portfolioId, data) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/trades`, { method: "POST",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).then(safeObj);

export const deleteTrade = (portfolioId, tradeId) =>
  apiFetch(`${BASE}/portfolios/${portfolioId}/trades/${tradeId}`, { method: "DELETE" });
